import { useEffect, useState, Children, isValidElement } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const Carousel = ({
  autoPlay = true,
  children,
  className = '',
  duration = 1500,
  height = 400,
  interval = 4000
}) => {
  const validChildren = Children.toArray(children).filter(isValidElement)
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    if (!autoPlay) return

    const id = setInterval(() => {
      setCurrent((prev) => (prev + 1) % validChildren.length)
    }, interval)

    return () => clearInterval(id)
  }, [validChildren.length, interval, autoPlay])

  return (
    <div
      className={className}
      style={{
        height,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <AnimatePresence>
        <motion.div
          key={current}
          initial={{ x: '100%', opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: '-100%', opacity: 0 }}
          transition={{ duration: duration / 1000, ease: 'easeInOut' }}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
          }}
        >
          {validChildren[current]}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export default Carousel
